import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { DocumentRequirementAttributeListViewModel } from '../models/document/document-requirement-attribute-list.model';
import { DocumentRequirementAttribute } from '../models/document/document-requirement-attribute.model';

@Injectable()
export class DocumentVerificationService extends BaseApiService {
    public getDocumentRequirementAttributes = (documentRequirementId: number): Observable<any> => this.get(`Driver/Document/${documentRequirementId}/Attributes`);

    public getLookups = (): Observable<any> => this.get('Driver/Document/Lookups');

    public saveDocumentRequirementAttributes = (model: DocumentRequirementAttributeListViewModel): Observable<any> => this.post('Driver/Document/Attributes', model);

    public saveDocumentRequirementAttribute = (model: DocumentRequirementAttribute): Observable<any> => this.post('Driver/Document/Attribute', model);

    public getTemporaryCredentialDocuments = (businessTransactionId: number): Observable<any> => this.get(`Driver/Document/TemporaryCredential/${businessTransactionId}`);

    public getCredentialApplicationDocuments = (businessTransactionId: number): Observable<any> => this.get(`Driver/Document/CredentialApplication/${businessTransactionId}`);

    public sendCredentialApplicationToCorrespondence = (businessTransactionId: number): Observable<any> => this.post(`Driver/Document/CredentialApplication/${businessTransactionId}/SendToCorrespondence`, null);

    public getSsaReferralDocuments = (businessTransactionId: number): Observable<any> => this.get(`Driver/Document/GetSsaReferralDocuments/${businessTransactionId}`);

    public sendSsaReferralDocumetToCorrespondence = (businessTransactionId: number): Observable<any> => this.post(`Driver/Document/SsaReferralDocumet/${businessTransactionId}/SendToCorrespondence`, null);
}
